import { FILE_MANAGER_COMPONENT_ACTIONS } from '../../../redux/file-manager-component/file-manager-component.actions';
import { Action } from '../../../redux/redux.types';
import { BrowserAssetType } from '../../../types/media-assets';
import { CURRENT_FILE_ASSETS_ACTIONS } from './current.actions';

export interface FilesBrowserState {
  type?: BrowserAssetType;
  fileId?: string;
}

const defaultState: FilesBrowserState = {
  type: undefined,
  fileId: undefined,
};

export const current = (
  state: FilesBrowserState = defaultState,
  { type, payload }: Action,
): FilesBrowserState => {
  switch (type) {
    case FILE_MANAGER_COMPONENT_ACTIONS.FILES_LIST_GET_SUCCESS:
      return { ...defaultState };

    case CURRENT_FILE_ASSETS_ACTIONS.FILE_SELECT: {
      const { fileId, type } = payload;
      return { ...state, fileId, type };
    }

    case CURRENT_FILE_ASSETS_ACTIONS.RESET_SELECTED_FILES: {
      return {
        type: undefined,
        fileId: undefined,
      };
    }

    default:
      return state;
  }
};
